import React from 'react';

import { FormLabel, Stack, TextField } from '@mui/material';

import { parseNumberInput } from '../../utils';

interface Props {
  error?: boolean;
  helperText?: string;
  label: string;
  required?: boolean;
  value?: number;
  onChange: (value: number | undefined) => void;
}

export default function PackageNumberField({ error, helperText, label, required, value, onChange }: Props) {
  return (
    <Stack spacing={1}>
      <FormLabel required={required}>{label}</FormLabel>
      <TextField
        type="number"
        value={value ?? ''}
        size="small"
        fullWidth
        error={error}
        helperText={helperText}
        slotProps={{ formHelperText: { sx: { ml: 0 } }, htmlInput: { min: 0 } }}
        onChange={(event) => onChange(parseNumberInput(event.target.value))}
      />
    </Stack>
  );
}
